var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.499,
    height: 37.999,
    viewBox: "0 0 28.499 37.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M22.25,0A14.269,14.269,0,0,0,8,14.25C8,24.48,21.276,37.293,21.84,37.833a.588.588,0,0,0,.819,0c.564-.54,13.84-13.353,13.84-23.583A14.269,14.269,0,0,0,22.25,0Zm0,20.781a6.531,6.531,0,1,1,6.531-6.531A6.531,6.531,0,0,1,22.25,20.781Z",
    transform: "translate(-8)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location_icon.07a65e7e92f124f847819cb0498b0d75.svg";
export { ForwardRef as ReactComponent };